import React from 'react'
import Layout from '../components/layout-global'
import About from '../components/about'

const page = () => (
  <Layout centered>
    <About />
  </Layout>
)

export default page
